import { call, put, takeLatest } from 'redux-saga/effects';
import axios from 'axios';
import { REQUEST, fetchSuccess, fetchFailure } from '../../actions/workspaces/list'
import config from '../../../config'; // Adjust the path based on where the file is located
import { getLocalUser } from '../../../utils/localUser';
import { Error } from '../../actions/error/error'
import { extractErrorMessage } from '../../../utils/apiResponseHandler';

function* operation() {
  try {
    const response = yield call(axios.get, 
      `${config.API_URL}/workspace`,
      { headers: getLocalUser() }
      );
    yield put(fetchSuccess(response.data.data));
  } catch (error) {
    yield put(Error(error))
    yield put(fetchFailure(extractErrorMessage(error)));
  }
}

export function* watch() {
  yield takeLatest(REQUEST, operation);
}
